<template lang="pug">
  details.dropdown.border-t.border-b.-mb-px.md-border-none.md-mb-10.group
    summary.py-18.pl-30.md-pl-15.md-py-0.focus-outline-none.cursor-pointer.relative.group-hover-text-app-text
      slot(name="title")
      chevron-y.absolute.right-20.top-0.h-full.flex.items-center.md-right-auto.md-left-0.md--rotate-90.md-scale-90
    .-mt-15.md-mt-15.md-pb-12
      slot
</template>

<script>
import ChevronY from '@/components/Icons/ChevronY'
export default {
  name: 'Dropdown',
  components: { ChevronY }
}
</script>

<style>
@import '../style/_settings.css';

details.dropdown[open] .icon-chevron-y{
  transform:scale(1, -1);
}

@media (--bkpt-md) {
  details.dropdown[open] .icon-chevron-y{
    /*transform:scale(1, -1);*/
    /*transform:scale(0.9,0.9);*/
    transform: scale(0.9,0.9);
  }
}
</style>
